import { render, staticRenderFns } from "./PrincipalDialog.vue?vue&type=template&id=45949252"
import script from "./PrincipalDialog.js?vue&type=script&lang=js&external"
export * from "./PrincipalDialog.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports